module.exports = __webpack_public_path__ + "img/card-payments.cf50c6ad.svg";